<div class="modal-header modal-block-primary">
  <button type="button" class="close" (click)="modalRef.hide()">
    <span aria-hidden="true">&times;</span>
    <span class="sr-only">Close</span>
  </button>
  <h4 class="modal-title">Choose a Remittance Remark</h4>
</div>
<div class="modal-body">
  <p>Choose a Remittance Remark:</p>
  <app-grid-wrapper
    #rarModalGrid
    [gridSize]="GridSize.small"
    (cellDoubleClicked)="select()"
    [autoHeight]="false"
  ></app-grid-wrapper>
</div>
<div class="modal-footer">
  <button
    type="button"
    class="btn btn-primary"
    (click)="select()"
    [disabled]="!rarModalGridSelection"
  >
    OK
  </button>
  <button type="button" class="btn btn-default" data-dismiss="modal" (click)="modalRef.hide()">
    Cancel
  </button>
</div>
